import { render, staticRenderFns } from "./LiveDetail.vue?vue&type=template&id=2ebc924e&scoped=true"
import script from "./LiveDetail.vue?vue&type=script&lang=js"
export * from "./LiveDetail.vue?vue&type=script&lang=js"
import style0 from "./LiveDetail.vue?vue&type=style&index=0&id=2ebc924e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebc924e",
  null
  
)

export default component.exports